import { render, staticRenderFns } from "./emojiPC.vue?vue&type=template&id=6079b8a6&scoped=true"
import script from "./emojiPC.vue?vue&type=script&setup=true&lang=ts"
export * from "./emojiPC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./emojiPC.vue?vue&type=style&index=0&id=6079b8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6079b8a6",
  null
  
)

export default component.exports